import { cva, type VariantProps } from "class-variance-authority"
import React from "react"
import { cn } from "~/common/cn"

export const textVariants = cva("", {
  variants: {
    variant: {
      default: "",
      heading1: "text-5xl font-extrabold",
      heading2: "text-4xl font-bold",
      heading3: "text-3xl font-bold",
      heading3_medium: "text-3xl font-medium",
      heading4: "text-lg font-semibold text-gray-900",
      heading4_medium: "text-lg font-medium text-gray-900",
      subheader: "text-sm font-medium text-gray-77",
      subheader_bold: "text-sm font-semibold text-gray-900",
      body: "text-sm font-medium",
      body_light: "text-xs",
    },
    wrapping: {
      default: "",
      wrap: "whitespace-pre-wrap break-words",
    },
  },
  defaultVariants: {
    variant: "default",
    wrapping: "default",
  },
})

export interface TypographyProps
  extends React.HTMLAttributes<HTMLHeadingElement>,
    VariantProps<typeof textVariants> {
  as?: React.ElementType
}

const Text = React.forwardRef<HTMLHeadingElement, TypographyProps>(
  ({ className, as: Comp = "span", variant, wrapping, ...props }, ref) => {
    return (
      <Comp className={cn(textVariants({ variant, wrapping, className }))} ref={ref} {...props} />
    )
  }
)
Text.displayName = "Text"

export default Text
